import { CampaignAsset } from './types';

/** Short human name for an asset type: the category prefix is dropped
 *  ("Homepage Banner 50%" → "Banner 50%"). */
export const shortAssetType = (t: string): string => t.replace(/^Homepage /, '');

/** Display name for a placement. The stored `title` is an optional LABEL
 *  appended to the generated name, never a replacement:
 *    - no label:            "Banner 50%"
 *    - label "teaser shot": "Instagram Post · teaser shot"
 *  With `withCampaign`, the campaign name is prefixed for views outside
 *  the campaign page: "Back to Work · Banner 50%". */
export const assetDisplayTitle = (
  a: Pick<CampaignAsset, 'title' | 'asset_type' | 'campaign_name'>,
  opts?: { withCampaign?: boolean },
): string => {
  const label = (a.title ?? '').trim();
  const base = label ? `${shortAssetType(a.asset_type)} · ${label}` : shortAssetType(a.asset_type);
  if (opts?.withCampaign && a.campaign_name) return `${a.campaign_name} · ${base}`;
  return base;
};
